import { render } from "./Termine.vue?vue&type=template&id=a4d4b71a"
import script from "./Termine.vue?vue&type=script&lang=js"
export * from "./Termine.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Git-Local\\afm.git - Kopie\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__